export default "__VITE_ASSET__CIMM27Gk__"